import React from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import toastSelectors from "~/store/toasts/selectors";
import { Alert } from "~/components-shared";
import toastsActionCreators from "~/store/toasts/actions";
import Markdown from "~/components/Markdown";
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    margin-bottom: 1em;
  }
`;
const Toasts = _ref => {
  let {
    ...rest
  } = _ref;
  const toasts = useSelector(toastSelectors.getToasts);
  const dispatch = useDispatch();
  const handleDelete = id => {
    if (id) {
      dispatch(toastsActionCreators.deleted(id));
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, rest, toasts.map(toast => /*#__PURE__*/React.createElement(Alert, {
    key: toast.id,
    severity: toast.severity,
    actions: [...(toast.actions || []), {
      icon: "cross",
      onClick: () => handleDelete(toast.id)
    }],
    timeout: toast.timeout,
    onTimeout: () => handleDelete(toast.id),
    maxWidth: "300px",
    fullWidth: true,
    shadow: true
  }, /*#__PURE__*/React.createElement(Markdown, {
    text: toast.message
  }))));
};
export default Toasts;